import * as type from './action-types';

const initialState = {
  locale: 'se',
  country: 'se',

  availableLocales: ['se', 'en'],
  availableCountries: ['sweden', 'england']
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.CHANGE_LOCALE:
      return Object.assign({}, state, {
        locale: action.payload
      });

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/redux/modules/i18n/reducer.js
 **/